<template>
    <div ref="container" class="container ">
        <div v-for="(shot, index) in shots" :key="index" :style="getShotStyle(shot)">
            <v-icon v-if="shot.throwStatus === 'made'" color="green" size="24">mdi-check-bold</v-icon>
            <v-icon v-else color="red" size="24">mdi-close-thick</v-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShootingChart',
        props: {
            shots: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
        }),
        methods: {
            getShotStyle(shot) {
                // Get current container size
                const container = this.$refs.container
                let width = 350
                let height = 350
                if (container) {
                    const rect = container.getBoundingClientRect()
                    width = rect.width
                    height = rect.height
                }
                // Convert percent to px, center icon
                const left = shot.x * width
                const top = shot.y * height
                return {
                    position: 'absolute',
                    left: `${left}px`,
                    top: `${top}px`
                }
            }
        }
    }
</script>

<style lang="css" scoped>
    .container {
        position: relative;
        cursor: pointer;
        width: 350px;
        height: 350px;
        min-width: 350px;
        min-height: 350px;
        background: url('../assets/halfcourt.jpg'), white;
        background-size: contain;
        overflow: hidden;
    }
</style>
